import { createFileRoute } from '@tanstack/react-router'
import NotFound404 from '~containers/general/404'

export const Route = createFileRoute('/404')({
  component: RouteComponent,
})

function RouteComponent() {
  return <NotFound404 />
}
